import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Heading, Spinner, VStack, Box, Alert, AlertIcon, Badge, HStack } from '@chakra-ui/react';
import DOMPurify from 'dompurify';
import { api } from '../lib/api';

// @ts-ignore
import '../algomed-styles/lecture-content.css';

export default function AlgospotView() {
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    api.getAlgospot(Number(id))
      .then(setData)
      .catch(() => setError('AlgoSpot yüklenemedi.'));
  }, [id]);

  if (error) return <Container maxW="md" py={6}><Alert status="warning"><AlertIcon />{error}</Alert></Container>;
  if (!data) return <VStack p={12}><Spinner /></VStack>;

  return (
    <Container maxW="2xl" py={6}>
      <VStack align="stretch" spacing={4}>
        {data.topic && <HStack><Badge colorScheme="orange">{data.topic.name}</Badge></HStack>}
        {data.title && <Heading size="md">{data.title}</Heading>}
        <Box
          className="lecture-reader"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.content) }}
        />
      </VStack>
    </Container>
  );
}
